<div class="countdown-timer">
	<!-- <h4 class="visible-xs">Countdown to Approval</h4> -->
	<div class="time-container flex-container">
		<ng-container *ngIf="showDays">
			<div class="time-section">
				<div class="time-value">
					{{ countDown.timer.days < 10? '0' +countDown?.timer?.days : countDown?.timer?.days }} </div>
						<div class="time-type">Days</div>
				</div>
				<span>:</span>
		</ng-container>
		<div class="time-section">
			<div class="time-value">
				{{ countDown.timer.hours < 10? '0' +countDown?.timer?.hours : countDown?.timer?.hours }} </div>
					<div class="time-type">Hours</div>
			</div>
			<span>:</span>
			<div class="time-section">
				<div class="time-value">
					{{ countDown.timer.minutes < 10? '0' +countDown?.timer?.minutes : countDown?.timer?.minutes }}
						</div>
						<div class="time-type">Minutes</div>
				</div>
				<span>:</span>
				<div class="time-section">
					<div class="time-value">
						{{ countDown.timer.seconds < 10? '0' +countDown?.timer?.seconds : countDown?.timer?.seconds }}
							</div>
							<div class="time-type">Seconds</div>
					</div>
				</div>
			</div>